export const parseTime = (str) => {
  if (!str) return 0;
  const [time, ampm] = str.split(" ");
  let [h, m] = time.split(":").map(Number);
  if (ampm?.toLowerCase() === "pm" && h !== 12) h += 12;
  if (ampm?.toLowerCase() === "am" && h === 12) h = 0;
  return h * 60 + m;
};
export const getLocalDate = (tz) => {
  if (!tz) return new Date();
  const now = new Date();
  const localStr = now.toLocaleString("en-US", { timeZone: tz });
  return new Date(localStr);
};

export const getDayName = (forecastDate, today = new Date()) => {
  const date = new Date(forecastDate);
  const options = { weekday: "long" };
  const dayName = new Intl.DateTimeFormat("en-US", options).format(date);
  const diffDays = Math.ceil((date - today) / (1000 * 60 * 60 * 24));
  return diffDays === 1 ? "Tomorrow" : dayName;
};

export const getArcPoint = (
  t,
  arcStart = { x: 10, y: 80 },
  arcControl = { x: 90, y: 0 },
  arcEnd = { x: 170, y: 80 }
) => {
  const x =
    (1 - t) * (1 - t) * arcStart.x +
    2 * (1 - t) * t * arcControl.x +
    t * t * arcEnd.x;
  const y =
    (1 - t) * (1 - t) * arcStart.y +
    2 * (1 - t) * t * arcControl.y +
    t * t * arcEnd.y;
  return { x, y };
};
